export const TESTIMONIALS_LOADING= 'TESTIMONIALS_LOADING';
export const GET_TESTIMONIALS= 'GET_TESTIMONIALS';
export const ON_TESTIMONIAL_ITEM_TAP= 'ON_TESTIMONIAL_ITEM_TAP';
export const ON_TESTIMONIAL_SLIDE_CHANGED= 'ON_TESTIMONIAL_SLIDE_CHANGED';
export const LOAD_TESTIMONIAL_ERROR= 'LOAD_TESTIMONIAL_ERROR';

